import { FormControl, FormHelperText, InputLabel, OutlinedInput } from "@mui/material";
import { forwardRef } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { IMaskInput } from "react-imask";

/**
 * PhoneMaskedInputBase
 */
interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

const PhoneMaskedInputBase = forwardRef<HTMLInputElement, CustomProps>((props, refs) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      placeholderChar="_"
      inputRef={refs}
      onAccept={(value: any, input: { unmaskedValue: string }) => {
        if (input.unmaskedValue.length > 0) {
          onChange({ target: { name: props.name, value } });
        } else {
          onChange({ target: { name: props.name, value: '' } });
        }
      }}
      lazy={false}
      overwrite={true}
      unmask={false}
    />
  );
});


/**
 * FormPhoneMaskedInput
 */

type Props<T extends {}> = {
  name: keyof T,
  type: 'movel' | 'fixo',
  label: string,
  reactHookForm: UseFormReturn<T>,
};

export const FormPhoneMaskedInput = <T extends {},>({
  name,
  type,
  label,
  reactHookForm,
}: Props<T>) => {
  return (
    <Controller
      name={name as any}
      control={reactHookForm.control}
      render={({ field, formState }) => {
        let helperText: string | null = null;

        if (name in formState.errors) {
          const error = formState.errors[name] as any;
          if (typeof error.message === 'string') {
            helperText = error.message;
          }
        }

        return (
          <FormControl variant="outlined" size="small">
            <InputLabel
              htmlFor={`input-${name as string}`}
              error={helperText !== null}
              shrink={true}
              size="small">
              {label}
            </InputLabel>

            <OutlinedInput
              size="small"
              id={`input-${name as string}`}
              name={name as string}
              value={field.value}
              label={label}
              notched={true}
              onChange={field.onChange}
              disabled={formState.disabled}
              error={helperText !== null}
              inputComponent={PhoneMaskedInputBase as any}
              inputProps={{
                mask: type === 'movel' ? '(00) 00000-0000' : '(00) 0000-0000',
                placeholder: type === 'movel' ? "(__) _____-____" : "(__) ____-____",
              }} />

            <FormHelperText id={`${name as string}-component-error-text`} error={true}>
              {helperText}
            </FormHelperText>
          </FormControl >
        );
      }} />
  );
}